import { jsx, Fragment } from "react/jsx-runtime";
import { Box, Text } from "braid-design-system";
import isNil from "lodash/isNil.js";
import { CoverImage } from "../../CoverImage/CoverImage.mjs";
import { root, placeholder, noCoverImage, image } from "../../CoverImage/CoverImage.css.mjs";
const Hero = ({
  id,
  cover,
  placeholderText,
  showCoverImage = true
}) => /* @__PURE__ */ jsx(Box, { position: "relative", "data-testid": `bx-brand-card-cover-${id}`, children: !isNil(cover) ? /* @__PURE__ */ jsx(CoverImage, { cover, showThumbnail: true }) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Box, { className: root, children: /* @__PURE__ */ jsx(
  Box,
  {
    className: [
      showCoverImage ? placeholder : noCoverImage,
      image
    ],
    children: /* @__PURE__ */ jsx(
      Box,
      {
        position: "absolute",
        textAlign: "center",
        width: "full",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "full",
        children: /* @__PURE__ */ jsx(Text, { size: "small", children: placeholderText })
      }
    )
  }
) }) }) });
export {
  Hero
};
